import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '@hvcgroep/design-system';

const InformationForm = () => {
  const { t } = useTranslation();

  return (
    <div
      className="form-item report-form-item"
    >
      <FormTextField name="fullName" label={t('reports.stepper.information.input.fullName')} />
      <FormTextField name="emailAddress" label={t('reports.stepper.information.input.emailAddress')} />
      <FormTextField name="phoneNumber" label={t('reports.stepper.information.input.phoneNumber')} optional />
    </div>
  );
};

export default InformationForm;
